export const environment = {
    production: false,
    hmr: false,
    development: true,
    apiurl: "https://apidev.renovationexchange.net/",
};
